/** The full-time job type in each locale's index ("Full-time", "Kokoaikainen", "Heltid"). */
const FULL_TIME_JOB_TYPES = new Set(['full-time', 'full time', 'kokoaikainen', 'heltid']);

/**
 * Full-time is the default contract, so cards and the job page name the job type only when it is
 * something else (part-time, temporary, ...).
 */
export function isFullTimeJobType(jobType: string | null | undefined): boolean {
  return Boolean(jobType && FULL_TIME_JOB_TYPES.has(jobType.trim().toLowerCase()));
}
